import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQOtpModel } from 'src/app/models/qq-otp-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { OtpService } from 'src/app/services/otp.service';

@Component({
  selector: 'app-apg-quick-quote-otp',
  templateUrl: './apg-quick-quote-otp.component.html',
  styleUrls: ['./apg-quick-quote-otp.component.scss'],
})
export class ApgQuickQuoteOtpComponent implements OnInit {
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() action: string;
  @Input() otpContentKey: string;

  @Output() next = new EventEmitter<{ code: string }>();
  @Output() back = new EventEmitter();

  mode: 'verify' | 'validate' | 'validated';
  otpId: number;
  email: string;
  mobile: string;
  preferredChannel: string;

  constructor(
    private otpService: OtpService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.mode = "verify";

    const [code, channel] = this.getOtpCode();
    if (code) {
      this.analyticsService.logEvent(`quickquote:contact_already_verified`, { channel });
      this.quickQuote.saveAnswer('OtpCode', code);
      this.mode = 'validated';
      setTimeout(() => this.next.emit({ code }));
    } else {
      this.analyticsService.logPageView('quickquote/verify_contact', { channel, page_title: 'Quick Quote | Verify Contact' });
    }
  }

  private getOtpCode() {
    const email = this.quickQuote.answersObject['FirstPolicyHolderEmail'];
    const mobile = this.quickQuote.answersObject['FirstPolicyHolderMobile'];
    const preferredChannel = this.action == 'sendViaSms' ? 'Mobile' : this.quickQuote.answersObject['PreferredChannel'];
    if (preferredChannel === 'Email') {
      return [this.otpService.getCode(email), preferredChannel];
    } else {
      return [this.otpService.getCode(mobile), preferredChannel];
    }
  }

  async saveOtpId(value: QQOtpModel) {
    this.otpId = value.otpId;
    this.mobile = value.mobile;
    this.email = value.email;
    this.preferredChannel = value.preferredChannel;
    this.mode = 'validate';
    this.analyticsService.logPageView('quickquote/validate_contact', {
      channel: this.preferredChannel,
      page_title: 'Quick Quote | Validate Contact'
    });
  }

  // async prev() {
  //   await this.quickQuote.currentPage.prevPage();
  // }

}
